import { defineComponent as _defineComponent } from 'vue'
import { CourseItem } from '@/entities/trainings';
  import RichText from '@/ui/components/richText/RichText.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Text',
  props: {
    item: {
      type: Object as () => CourseItem,
      required: true,
    },
  },
  setup(__props) {

  

return { __sfc: true,RichText }
}

})